module.exports = __webpack_public_path__ + "static/media/kairavi.29245c6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Artist/static/images/kairavi.jpg
// module id = 110
// module chunks = 1